import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

export const StyledNotifyLowCreditsDialogContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .description {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    text-align: center;
    vertical-align: middle;
    color: ${COLOR.darkGray};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .character-container {
      margin: 0;
    }
  }
`;
